var map = {
	"./CCI-Logo.png": 56283,
	"./Calendar.png": 74761,
	"./Calendar2.png": 54749,
	"./Cephas.png": 62615,
	"./Delete.png": 93095,
	"./Doneimg.png": 41578,
	"./Edit.png": 88362,
	"./Filters.png": 70821,
	"./Graph.png": 95723,
	"./Graph2.png": 43070,
	"./Group 482228.png": 45401,
	"./Group 482505.png": 85154,
	"./Group43.png": 39129,
	"./Group44.png": 83841,
	"./Group48.png": 40970,
	"./Group482.png": 89205,
	"./Group55.png": 8373,
	"./Group66.png": 79471,
	"./ICS Logo FA.png": 21857,
	"./ICS logo.png": 47899,
	"./Imageframe.png": 99417,
	"./Line1.png": 14131,
	"./Line13.png": 63989,
	"./Line2.png": 44473,
	"./Logo FA 1.png": 7556,
	"./Logo FA.svg": 36350,
	"./LogoFA.svg": 926,
	"./OrderPer.png": 48536,
	"./Purchase1.png": 11170,
	"./Purchase2.png": 69339,
	"./Purchase3.png": 99767,
	"./Purchase4.png": 65629,
	"./Purchase5.png": 35024,
	"./Purchase6.png": 70264,
	"./Rectangle99.png": 57299,
	"./Sales.png": 66518,
	"./Sales2.png": 88649,
	"./Sales3.png": 69484,
	"./Sales4.png": 23350,
	"./Sales5.png": 46983,
	"./Sales6.png": 94401,
	"./Searchcustomer.png": 72170,
	"./Totalicon.png": 81605,
	"./Vectorright.png": 99161,
	"./address.svg": 74792,
	"./attendance.svg": 32077,
	"./avatar3.png": 75664,
	"./bg.png": 95878,
	"./birthdayImg.png": 97213,
	"./blackArrow.png": 19931,
	"./blackbirthday.png": 75445,
	"./bluecircle.png": 34027,
	"./blueicon.png": 14463,
	"./brand.png": 82593,
	"./calender.png": 5922,
	"./carbon_view.svg": 98898,
	"./delete.gif": 4988,
	"./delete.svg": 64217,
	"./deleteimg.png": 4717,
	"./download.svg": 98728,
	"./edit.svg": 68044,
	"./email.svg": 99168,
	"./fluent_delete-28-regular.svg": 42260,
	"./fonts/Poppins.otf": 22352,
	"./fonts/Sansation_Regular.ttf": 40619,
	"./fonts/calibril.ttf": 60517,
	"./fonts/inter.ttf": 20628,
	"./fonts/micross.ttf": 24525,
	"./fonts/regular.otf": 20931,
	"./fonts/segoe.ttf": 27454,
	"./greencircle.png": 26792,
	"./greenicon.png": 38823,
	"./hiring.png": 95609,
	"./homeimage.png": 20093,
	"./humanProfile.png": 41806,
	"./icon-wrapper-h.png": 72551,
	"./icon2.png": 37535,
	"./icon3.png": 77078,
	"./icon4.png": 91459,
	"./icon5.png": 22239,
	"./icon6.png": 1935,
	"./icon7.png": 40083,
	"./icon8.png": 31919,
	"./iconDelete1.png": 83861,
	"./iconedit.svg": 17623,
	"./icons8-cancel.gif": 21247,
	"./icslogo.png": 76208,
	"./invlogo.svg": 72391,
	"./items-search.png": 29730,
	"./jobbg.png": 11105,
	"./loginimg.png": 27078,
	"./loginshape.svg": 95195,
	"./logo.svg": 69574,
	"./logol.svg": 58260,
	"./logonew.svg": 99294,
	"./news.png": 20463,
	"./notification.svg": 90313,
	"./notificationicon.svg": 36661,
	"./notifications.svg": 3213,
	"./notify.svg": 20827,
	"./party.png": 20381,
	"./per100.png": 12025,
	"./phone.svg": 56289,
	"./photo-1.png": 8230,
	"./photo-2.png": 35119,
	"./photo-3.png": 29908,
	"./photo-4.png": 61948,
	"./photo-5.png": 63863,
	"./photo.jpg": 94447,
	"./pinkbirthday.png": 497,
	"./placeimg.png": 69973,
	"./qrcode.svg": 31465,
	"./register.png": 72437,
	"./require.png": 36584,
	"./salesreportimg.png": 32923,
	"./sent.svg": 84527,
	"./serviceimg.png": 86154,
	"./shield.png": 34542,
	"./signupbg.png": 19270,
	"./skybluebirthday.png": 49679,
	"./successful.svg": 16916,
	"./tanta.png": 10257,
	"./thanks.png": 32521,
	"./upicon.png": 81033,
	"./user1.png": 49153,
	"./user2.png": 68458,
	"./user3.png": 62701,
	"./user4.png": 98630,
	"./user5.png": 58890,
	"./user6.png": 73364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;